export function validateCompare(value: any, obj: any, otherPropertyName: string) {
	 
	 return	value === null
		|| value === undefined
		|| value === ''
		|| obj[otherPropertyName] === null
		|| obj[otherPropertyName] === undefined
		|| obj[otherPropertyName] === ''
		|| value === obj[otherPropertyName]
		
}